'use strict';

class MoveStoreController {
  /*@ngInject*/
  constructor($scope, $stateParams, $state, orderStore, $q) {
    "ngInject";
    _.extend(this, {
      $scope: $scope,
      $stateParams: $stateParams,
      $state: $state,
      $q: $q,
      orderStore: orderStore
    });
    this.order = this.orderStore.getOrder($stateParams.orderId);
    this.to = this.order.to_address_attributes;
    this.from = this.order.from_address_attributes;
  }

  houseTypes = [
    {displayName: '1 BHK', value: '1_BHK'},
    {displayName: '2 BHK', value: '2_BHK'},
    {displayName: '3 BHK', value: '3_BHK'},
    {displayName: '3+ BHK', value: '4_BHK'},
    {displayName: 'vehicle', value: 'vehicle'},
    {displayName: 'few items', value: 'items'},
    {displayName: 'duplex villa', value: 'DUPLEX_VILLA'}
  ]

  findLocality(searchText) {
    if (_.isEmpty(searchText)) {
      return undefined;
    }
    let deferred = this.$q.defer();
    piko.googlePlaces.getPlacePredictions({input: searchText, componentRestrictions: {country: 'in'}}, function (data) {
      deferred.resolve(data);
    });
    return deferred.promise;
  }

  getAddressAttributesFrom(googlePlace) {
    return {
      placeId: googlePlace.place_id,
      name: googlePlace.description
    };
  }
  
  goToFloor() {
    _.extend(this.order.from_address_attributes, this.getAddressAttributesFrom(this.from));
    _.extend(this.order.to_address_attributes, this.getAddressAttributesFrom(this.to));
    this.orderStore.saveOrder(this.order);
    this.$state.go('base.floor', {orderId: this.$stateParams.orderId});
  }
}

MoveStoreController.bindings = {
  bhk: '=',
  from: '=',
  to: '=',
  moveDate: '='
}


export default MoveStoreController;


// WEBPACK FOOTER //
// ./client/app/components/movestore/movestore.controller.js